module.exports = __webpack_public_path__ + "static/img/preview-green-with-progress-bar.3a445d28.png";